import React from "react";

interface Props {
  isOpen: boolean;
}
const TugChairBehindPatientModal: React.FC<Props> = ({ isOpen }) => {
  if (isOpen) {
    return (
      <div className="assessmet-complete-wrap counter-center-sec">
        <div className="assessmnet-text-wrap">
          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "50px",
              color: "white",
            }}
          >
            Participant is within the bounding box!
          </p>

          <p
            style={{
              fontSize: "64px",
              fontWeight: "700",
              lineHeight: "87.16px",
              textAlign: "center",
              marginBottom: "50px",
              color: "white",
            }}
          >
            Make sure the chair is safely positioned behind the patient.
          </p>
        </div>
      </div>
    );
  }
  return <React.Fragment />;
};
export default TugChairBehindPatientModal;
